"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Desktop Icon
 * See: https://www.figma.com/file/QuTgaMHPcPtE2qNJtbp76m/Lens-Page?node-id=4536%3A57785
 */
function DesktopIcon(props) {
    switch (props.size) {
        // todo: add different sizes.
        default:
            return (0, jsx_runtime_1.jsx)(ReactBasedDesktopIcon, {});
    }
}
exports.DesktopIcon = DesktopIcon;
// SVG code copied from Desktop Icon(./Medium.svg)
function ReactBasedDesktopIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: 21, height: 13, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.469.972c.059.142.09.295.09.449h.007v9.575H2.182V1.421A1.173 1.173 0 0 1 3.354.248h14.032a1.173 1.173 0 0 1 1.083.724ZM3.549 9.628H17.19V1.616H3.55v8.012Zm8.58 1.957a.435.435 0 0 0-.048-.198h8.159c0 .89-.803 1.613-1.79 1.613H2.29C1.301 13 .5 12.278.5 11.387h8.158a.434.434 0 0 0 .082.51.44.44 0 0 0 .311.128h2.638a.44.44 0 0 0 .44-.44Z", fill: "#000" }) }));
}
//# sourceMappingURL=DesktopIcon.js.map